import API from "./API";

const tokenService = {
    checkDate: (date: string) => {
        const actualDate = new Date();
        const tokenDate = new Date(date);
        if (actualDate < tokenDate) return true
        return false
    },
    checkTokenDate: () => {
        const user = window.localStorage.user;
        if (user) {
            const parsedUser = JSON.parse(user);
            return !!parsedUser.token
        } return false
    },
    getToken: async () => {
        const user = window.localStorage.user;
        if (user) {
            const parsedUser = JSON.parse(user);
            if (tokenService.checkDate(parsedUser.tokenExpiration)) {
                return parsedUser.token;
            } else {
                const token = await API.refreshToken(parsedUser.token, parsedUser.refreshToken)
                const tokenData = token.data.data;
                parsedUser.token = tokenData?.token;
                parsedUser.refreshToken = tokenData?.refreshToken;
                parsedUser.tokenExpiration = tokenData?.tokenExpiration;
                window.localStorage.setItem('user', JSON.stringify(parsedUser));
                return token.data.data?.token;
            }
        } return ''
    }
};
export default tokenService;